import { render, staticRenderFns } from "./Formatos.vue?vue&type=template&id=951943ce&scoped=true"
import script from "./Formatos.vue?vue&type=script&lang=js"
export * from "./Formatos.vue?vue&type=script&lang=js"
import style0 from "./Formatos.vue?vue&type=style&index=0&id=951943ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951943ce",
  null
  
)

export default component.exports